module.exports = __webpack_public_path__ + "img/16-full-md.349ab2f0.jpg";